<template>
  <div class="app-container">
    <keep-alive include="InvoiceSubmitpage">
      <router-view></router-view>
    </keep-alive>
  </div>
</template>

<script>
import Vue from 'vue'
import { NavBar, Divider } from 'vant'

Vue.use(NavBar).use(Divider)
export default {
  data() {
    return {
      data: 111
    }
  },
  created() {
    document.body.addEventListener('touchstart', function () {})
  },
  methods: {
    onClickLeft() {
      this.$router.back()
    }
  }
}
</script>

<style lang="scss" scoped>
.app-container {
  max-width: 750px;
  margin: 0 auto;
}
</style>
